import { use } from "react";
import { AuthContext } from "@/lib/Auth/AuthProvider";

export function useAuth() {
  return use(AuthContext);
}
